import { apiFetch, apiUpload } from './client';
import type { Hand, HandListItem } from '../types/mjai';

export interface HandUpdatePayload {
  title?: string;
  is_public?: boolean;
}

export async function listHands(params?: {
  page?: number;
  page_size?: number;
  mine?: boolean;
  q?: string;
}): Promise<HandListItem[]> {
  const query = new URLSearchParams();
  if (params?.page) query.set('page', String(params.page));
  if (params?.page_size) query.set('page_size', String(params.page_size));
  if (params?.mine) query.set('mine', 'true');
  if (params?.q) query.set('q', params.q);
  return apiFetch<HandListItem[]>(`/hands?${query}`);
}

export async function getHand(id: string): Promise<Hand> {
  return apiFetch<Hand>(`/hands/${id}`);
}

export async function createHandWithImage(formData: FormData): Promise<Hand> {
  return apiUpload<Hand>('/hands', formData);
}

export async function updateHand(id: string, payload: HandUpdatePayload): Promise<Hand> {
  return apiFetch<Hand>(`/hands/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}

export async function deleteHand(id: string): Promise<void> {
  await apiFetch<void>(`/hands/${id}`, { method: 'DELETE' });
}

export async function getTrendingHands(
  period: 'day' | 'week' | 'month' | 'all' = 'week',
  page: number = 1,
): Promise<HandListItem[]> {
  return apiFetch<HandListItem[]>(`/hands/trending?period=${period}&page=${page}&page_size=100`);
}
